import React from "react";
import moment from "moment";
import { formatMonto } from "../../utils";
import useProyecto from "../../hooks/useProyecto";

const PagoCard = ({ pago, handleEdit }) => {
  const { permiso } = useProyecto();

  const renderStatus = () => {
    if (pago.fecha_cancelacion !== null) {
      return <span className="badge bg-danger">Cancelado</span>;
    }
    if (pago.fecha_hora_autorizacion !== null) {
      return <span className="badge bg-success">Autorizado</span>;
    }
    return <span className="badge bg-warning text-dark">Pendiente</span>;
  };

  const renderFecha = () => {
    if (pago.fecha_cancelacion !== null) {
      return moment(pago.fecha_cancelacion).format("DD MMM YYYY");
    }
    if (pago.fecha_hora_autorizacion !== null) {
      return moment(pago.fecha_hora_autorizacion).format("DD MMM YYYY");
    }
    return null;
  };

  const fecha = renderFecha();
  const canEdit = ["admin", "finanzas"].includes(permiso);

  return (
    <div className="card border shadow-sm mb-2 w-100">
      <div className="card-body py-3 px-3">
        <div className="d-flex justify-content-between align-items-start">
          <div className="flex-grow-1">
            <h3 className="h5 mb-2 bold">
              ${formatMonto(pago.monto)}{" "}
              <span className="text-muted small fw-normal">MXN</span>
            </h3>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              {renderStatus()}
              {fecha && <span className="text-muted small">{fecha}</span>}
            </div>
          </div>
          {canEdit && (
            <button
              className="btn btn-sm btn-outline-primary flex-shrink-0"
              onClick={() => handleEdit(pago)}
            >
              <i className="fa fa-edit" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PagoCard;
